/*
 * Project: LegalPlace assistant
 * File: src/components/buy/invoice.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  invoiceUpdateName,
  invoiceUpdateVisibility,
  invoiceUpdateCity,
  invoiceUpdateAddress,
  invoiceUpdateTVA,
  invoiceUpdateZip,
} from '../../redux/actions/checkout_operations';


class LpInvoice extends Component {
  constructor(props) {
    super(props);
    this.visiblityCallback = this.visiblityCallback.bind(this);
    this.nameCallback = this.nameCallback.bind(this);
    this.addressCallback = this.addressCallback.bind(this);
    this.cityCallback = this.cityCallback.bind(this);
    this.zipCallback = this.zipCallback.bind(this);
    this.tvaCallback = this.tvaCallback.bind(this);
  }

  visiblityCallback() {
    this.props.toggleInvoice();
  }

  nameCallback(evt) {
    this.props.updateName(evt.target.value);
  }

  addressCallback(evt) {
    this.props.updateAddress(evt.target.value);
  }

  cityCallback(evt) {
    this.props.updateCity(evt.target.value);
  }

  zipCallback(evt) {
    this.props.updateZIP(evt.target.value);
  }

  tvaCallback(evt) {
    this.props.updateTVA(evt.target.value);
  }


  render() {
    return (
      <section className="hidden-xs page-section">
        <div className="cb-title form-group lp-chbx">
          <input type="checkbox" id="facture" name="facture" className="" onChange={this.visiblityCallback} style={{ marginRight: '10px' }} value={this.props.visible} />
          <label htmlFor="facture">Je souhaiterais recevoir une facture (optionnel)</label>
        </div>
        { this.props.visible
                && (
                <div className="vars ng-scope">
                  <div className="title">
                    <h2 className="section-title">
                      {/* eslint-disable-next-line */}
                        Veuillez renseigner ces informations, si vous souhaitez recevoir une facture.
                    </h2>
                  </div>
                  <div className="cr-container">
                    <div className="form-group">
                      <label>Nom et Prénoms ou Nom de la Société:</label>
                      <input type="text" name="organization" className="form-control" onChange={this.nameCallback} />
                    </div>
                    <div className="form-group">
                      <label>Adresse complète :</label>
                      <input type="text" name="address" className="form-control" onChange={this.addressCallback} />
                    </div>
                    <div className="row">
                      <div className="col-md-7 form-group">
                        <label>Ville :</label>
                        <input type="text" name="city" className="form-control" onChange={this.cityCallback} />
                      </div>
                      <div className="col-md-5 form-group">
                        <label>Code postal :</label>
                        <input type="text" name="zip_code" className="form-control" onChange={this.zipCallback} />
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Numéro de TVA (si applicable) :</label>
                      <input type="text" name="nb_tva" className="form-control" onChange={this.tvaCallback} />
                    </div>
                  </div>
                </div>
                )
        }
      </section>
    );
  }
}


const mapStateToProps = state => ({
  visible: state.checkout_operations.toggle_invoice,
});

const mapDispatchToProps = dispatch => ({
  toggleInvoice: () => {
    dispatch(invoiceUpdateVisibility());
  },
  updateName: (val) => {
    dispatch(invoiceUpdateName(val));
  },
  updateCity: (val) => {
    dispatch(invoiceUpdateCity(val));
  },
  updateAddress: (val) => {
    dispatch(invoiceUpdateAddress(val));
  },
  updateTVA: (val) => {
    dispatch(invoiceUpdateTVA(val));
  },
  updateZIP: (val) => {
    dispatch(invoiceUpdateZip(val));
  },
});


export default LpInvoice = connect(mapStateToProps, mapDispatchToProps)(LpInvoice);



// WEBPACK FOOTER //
// ./src/components/buy/invoice.js